export const LANG_SET = 'LANG_SET';

